export default __webpack_public_path__ + "static/media/ABARTH.46ffee85.png";